<template>
  <div
    class="work-frame"
    :style="workFrameStyle"
  >
    <div class="image-container">
      <a v-if="link" :href="link" target="_blank">
        <div class="image" :style="imageStyle"></div>
      </a>
      <div v-if="!link" class="image" :style="imageStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'image',
    'ratio',
    'link',
  ],
  data() {
    return {
      isHovered: false,
    };
  },
  computed: {
    workFrameStyle() {
      if (this.width < 1) {
        return {
          height: `${this.width / this.ratio * 100}%`,
        };
      }

      return {
        height: `${this.width / this.ratio}px`,
      };
    },
    imageStyle() {
      return {
        backgroundImage: `url(${this.image})`,
        paddingTop: `${100 / this.ratio}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.work-frame {
  background: #fff;
  border: 6px solid #333;
  box-shadow: 0px 6px 24px 0px rgba(0,0,0,0.4), inset 0px 1px 6px 0px rgba(0,0,0,0.50);
  position: relative;
  transform: scale(1);
  transition: all 0.3s;
  width: 100%;

  &:hover {
    box-shadow: 0px 9px 36px 0px rgba(0,0,0,0.2), inset 0px 1px 6px 0px rgba(0,0,0,0.50);
    transform: scale(1.03);
    transition: all 0.6s;
  }
}

.image {
  background-position: center;
  background-size: cover;
  box-shadow: inset 0px 1px 4px 0px rgba(0,0,0,0.50);
  display: block;
  width: 100%;

  &-container {
    padding: 30px;
    width: 100%;
  }
}
</style>



/** WEBPACK FOOTER **
 ** WorkFrame.vue?31d3e2d9
 **/